import styled, { css, keyframes } from "styled-components";

export type MobileChatView = "minimized" | "medium";

export const Container = styled.div<{ $mobileView: MobileChatView , $isMinimized?: boolean}>`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: var(--cloud-gray);
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: var(--primary-blue) transparent;
  gap: 1rem;
  width: 100%;
  padding-bottom: 5px;


  
  ${({ $isMinimized }) =>
    $isMinimized &&
    css`
      position: fixed;
      top: auto;
      left: auto;
      bottom: 1.5rem;
      right: 1.5rem;
      width: clamp(320px, 30vw, 420px);
      height: 80vh;
      max-height: 600px;
      z-index: 1000;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
      border-radius: 2px;
      overflow: hidden;
      resize: none;

    `}

     @media (max-width: 768px) {
        display: flex;
        padding: 0;
        height: 100%;

      ${({ $mobileView }) =>
        $mobileView === "medium" &&
        css`
          max-height: 35vh;

          .message-content{
            min-width: 80vw;
          }
          gap: 0.3rem;
        `}


      ${({ $mobileView }) =>
        $mobileView === "minimized" &&
        css`
          height: 22vh;
          .message-content{
            h3{
              font-size: 0.9rem;
            }
          }
          gap: 0.2rem;
        `}
  }
`;

export const Header = styled.div`
  position: sticky;
  top: 0;
  z-index: 10;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
  background-color: blue;
  color: var(--white);
  background-color: var(--primary-blue);
  padding: 1rem 2rem;

  h1 {
    font-size: 1.7rem;
  }

  .header-icon{
    padding: 12px;
    cursor: pointer;
    border: none;
    background-color: var(--primary-blue);
  }

  .header-icon:hover {
    background-color: var(--hover);
  }

  
  img {
    width: 1.5rem;
    height: 1.5rem;
  }

  @media (max-width: 768px) {
    position: sticky;
    top: 0;
    z-index: 10;

    padding: 0.8rem 1rem;
    margin-bottom: 0;

    h1 {
      font-size: 1.8rem;
    }


    img {
      width: 1rem;
      height: 1rem;
    }
    &::after {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 36px;
      height: 2px;
      border-radius: 2px;
      background-color: var(--white);
    }
  }

  

`;

// export const MobileControls = styled.div`
//     display: none;
//      @media (max-width: 768px) {
//       display: flex;
//       position: sticky;
//       top: 4rem; 
//       z-index: 11;
//       justify-content: flex-end;
// }

// `;



export const ToggleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  padding: 0;
  border: none;
  color: black;
  background-color: transparent;

  cursor: pointer;

  img {
    filter: invert(45%) sepia(90%) saturate(2000%) hue-rotate(190deg) brightness(50%);
    width: 1.3rem;
    height: 1.3rem;
    background-color: transparent;
  }


  &:focus-visible {
    outline: 2px solid var(--light-green);
    outline-offset: 2px;
  }
`;



export const Message = styled.div<{ $sender: "lisa" | "user"; $mobileView: MobileChatView;  $isMinimized?: boolean }>` 
  display: flex;
  flex-direction: column;
  align-items: ${({ $sender }) => ($sender === "user" ? "flex-end" : "flex-start")};
  align-self: ${({ $sender }) => ($sender === "user" ? "flex-end" : "flex-start")};
  text-align: left;
  padding: 0 1rem;
  

  ${({ $isMinimized }) =>
    $isMinimized &&
    css`  
      width: 95%;
      gap: 1rem;
    `}



   .message-content {
      display: flex;
      justify-content: space-between;
      background: ${({ $sender }) => ($sender === "user" ? "var(--cyan)" : "var(--white)")};
      color: black;
      margin: 0;
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
      min-height: 85px;
      width: 45vw;
      padding: 1rem;
      align-items: center;
      font-weight: 500;
      h3{
        font-weight: 500;
      }

      ${({ $isMinimized }) =>
      $isMinimized &&
      css`  
        width: 95%;
        gap: 1rem;
      `}
  }

  @media (max-width: 768px) {
    padding: 0.2rem;
    .message-content {
      width: 92vw;
      min-height: 50px;
    }

   h3{
        font-size: 1.1rem;
      }


    ${({ $mobileView }) =>
      $mobileView === "minimized" &&
      css`
        
        .message-content {
          font-size: 0.8rem;
          padding: 12px;
          margin: 0;
          min-height: 20px;
          width: 95vw;
        }
        
       
      `}
}

 
  .message-time {
    font-size: 0.75rem;
    color: black;
    margin-top: 2px;
  }
`;

export const HighlightedWord = styled.span`
  font-weight: 700;
  text-decoration: dotted bold;


  &:hover {
    opacity: 0.8;
  }

  &:focus-visible {
    outline: 2px solid #ffb020;
    outline-offset: 2px;
    border-radius: 2px;
  }
`;

export const InitialMessageContainer = styled.div<{ $isMinimized?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 100%;
  gap: 1rem;
  box-sizing: border-box;
  overflow: hidden;

  .initial-message-title {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 1.5rem;
    max-width: 100%;
    padding: 0 1rem;
    box-sizing: border-box;

    h1 {
      font-size: 1.3rem;
      font-weight: 500;
      white-space: normal;
      min-width: 0;
      flex: 1 1 260px;
    }

    .logoLisa{
      flex-shrink: 0;
    }
  }

  .initial-message-subjects {
    display: flex;
    align-items: center;
    gap: 1rem;
    width: 100%;
    justify-content: center;
  }

  .subjects-grid {
    display: grid;
    grid-template-columns: repeat(3, 220px);
    gap: 1rem;
  }

  .subject-button{
    color: var(--primary-blue);
    height: 48px;
    border: 1px solid var(--primary-blue);
    border-radius: 2px;
    background: white;
    cursor: pointer;
    transition: 0.2s;
  }

  .show-more-button {
    color: var(--primary-blue);
    background: none;
    cursor: pointer;
    transition: 0.2s;
    border: none;
    display: flex;
    align-items: center;
    font-size: 1rem;
    gap: 0.5rem;
    font-weight: 600;

    img{
      width: 1.2rem;
      height: 1.2rem;
    }
  }

  .subject-button:hover {
    background: #f5f5f5;
  }

  @media (max-width: 768px) {
    .initial-message-title {
      gap: 1rem;
      padding: 0 0.75rem;

      h1 {
        font-size: 1rem;
        flex-basis: 200px;
      }

      .logoLisa {
        width: 2.5rem;
        height: 2.5rem;
      }

      
    }

    .subjects-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      width: 100%;
      padding: 0 0.75rem;
      box-sizing: border-box;
    }
  }

  ${({ $isMinimized }) =>
    $isMinimized &&
    css`
      .initial-message-title {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        gap: 1rem;
        max-width: 100%;

        h1 {
          font-size: 0.9rem;
          font-weight: 500;
          white-space: normal;
          min-width: 0;
          flex: 1 1 200px;
        }
      }

      .subjects-grid {
        display: grid;
        grid-template-columns: repeat(3, 110px);
        gap: 0.9rem;
      }
    `}
`;

export const bounce = keyframes`
  0%, 60%, 100% { transform: translateY(0); opacity: 0.4; }
  30% { transform: translateY(-4px); opacity: 1; }
`;

export const TypingDots = styled.div`
  display: flex;
  gap: 4px;
  padding: 4px 0;

  span {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: currentColor;
    animation: ${bounce} 1.2s infinite ease-in-out;
  }

  span:nth-child(2) { animation-delay: 0.15s; }
  span:nth-child(3) { animation-delay: 0.3s; }
`;